import React from "react";
import {
	Box,
	IconButton,
	InputAdornment,
	inputBaseClasses,
	MenuItem,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Iconify } from "@onair/minimal-ui/iconify";
import { AddressScope, TicketScope } from "@onair/repositories";
import EventSessionAddressBox from "./event-session-address-box.tsx";

interface PropTypes {}

export const AddressField: React.FC<{
	name: string;
}> = ({ name }) => {
	return (
		<Field.Text
			name={name}
			label="Địa điểm"
			required
			placeholder="Nhập địa điểm"
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Iconify
							sx={{
								color: "action.active",
							}}
							width={24}
							icon="mingcute:location-fill"
						/>
					</InputAdornment>
				),
			}}
		/>
	);
};

const AddressScopeBox: React.FC<PropTypes> = () => {
	const { control } = useFormContext();

	const addressScope = useWatch({
		name: "stepPricing.addressScope",
		control,
	});

	const isAddressForAll = addressScope === AddressScope.ALL;

	const { fields: eventSessions } = useFieldArray({
		control,
		name: "stepTimeline.sessions",
		keyName: "_id",
	});

	return (
		<Stack spacing={2}>
			<Field.Select
				name={`stepPricing.addressScope`}
				label=""
				sx={{
					flex: 1,
					[`& .${inputBaseClasses.root}`]: {
						backgroundColor: "white",
					},
					[`& p`]: {
						textTransform: "none",
					},
				}}
				required
				value={addressScope}
			>
				{[
					{
						label: (
							<Typography variant="body2">
								Chuỗi sự kiện có cùng địa điểm
							</Typography>
						),
						value: AddressScope.ALL,
					},
					{
						label: (
							<Typography variant="body2">
								Chuỗi sự kiện không cùng địa điểm
							</Typography>
						),
						value: TicketScope.EACH,
					},
				].map((el) => {
					return (
						<MenuItem key={el.value} value={el.value}>
							{el.label}
						</MenuItem>
					);
				})}
			</Field.Select>

			{isAddressForAll ? (
				<AddressField name="stepPricing.address" />
			) : (
				<Stack spacing={2}>
					{eventSessions.map((_, index) => (
						<EventSessionAddressBox index={index} />
					))}
				</Stack>
			)}
		</Stack>
	);
};

export default AddressScopeBox;
